import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  & > .accordion {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;

    & > .card:not(:first-of-type):not(:last-of-type) {
      border-bottom: 1px solid #0000ff;
      border-radius: 4px;
    }

    & > .card {
      width: 100%;
      border: 1px solid #0000ff;
      border-radius: 4px;

      .card-header {
        background-color: white;
        border: none;
        padding: 13px 25px;
        color: #0000ff;
        font-size: 1.1rem;
        line-height: 22px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        > svg {
          min-width: 20px;
          min-height: 20px;
        }
      }

      .card-body {
        padding: 0 25px 10px;
        color: #7a7a7a;
        font-size: 0.9375rem;
        line-height: 22px;
        font-weight: 300;
        display: flex;
        flex-direction: column;

        > span {
          font-weight: 700;
          color: #000;
          width: 100%;
          margin-top: 10px;
        }

        > p {
          margin: 0;

          > span {
            width: 100%;
            display: flex;
          }
        }

        b {
          font-weight: 700;
        }

        a {
          color: #000fff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .card-header {
      padding: 10px 15px !important;
      gap: 5px !important;
    }

    .card-body {
      padding: 0 15px 10px !important;
    }
  }
`;
